import s from '../styles/SessionBadges.module.scss'

const PRIMARY_LABELS = {
	done: 'Completed',
	active: 'Active',
	next: 'Next ',
	not_run: 'Not Started',
}

export default function useSessionBadges(status) {
	if (!status?.primary) {
		return null
	}

	return {
		className: [s.badge, s[`badge_${status.primary}`]]
			.filter(Boolean)
			.join(' '),
		label: PRIMARY_LABELS[status.primary],
	}
}
